import Header from "./components/layout/Header";
import Banner from "./components/layout/Banner";
import EspEvolution from "./components/layout/EspEvolution";
import RealMadrid from "./components/layout/RealMadrid";
import EspAcademy from "./components/layout/EspAcademy";
import WorldChallenge from "./components/layout/WorldChallenge";
import EspSocial from "./components/layout/EspSocial";
import EspExperience from "./components/layout/EspExperience";
import Gallery from "./components/layout/Gallery";
import Footer from "./components/layout/Footer";

function App() {
  return (
    <div style={{ position: "relative" }}>
      <Header />
      <Banner />
      <EspEvolution />
      <RealMadrid />
      <WorldChallenge />
      <EspAcademy />
      <EspExperience />
      <EspSocial />
      <Gallery />
      <Footer />
    </div>
  );
}

export default App;
